<template>
  <div id="app" ref="grcapp">
    <resize-observer @notify="MainResizeEvent" />

    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>

    <AppFrameTopMenu ref="AppFrameTopMenu" />

    <div class="maincontentbox" :style="{'background-color':bgcolor}">
        <router-view ref="currentform"
        v-on:handlecommerror="HandleCommError"
        v-on:navigate="ChildForm_Navigate"
        v-on:changepagebg="ChangePageBackground"
        v-on:setappheaderversion="SetAppHeaderVersion"
        ></router-view>
    </div>


    <AppFooter ref="AppFooter" ></AppFooter>
    
  </div>

</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';

import GrcDB from './components/GrcComponents/GrcDB.vue'
import AppFooter from './components/AppFrame/AppFooter.vue'
import Splitpanes from 'splitpanes'
import GrcDialog from './components/GrcComponents/GrcDialog.vue'
import GrcButton from './components/GrcComponents/GrcButton.vue'
import AppFrameTopMenu from './components/AppFrame/TopMenu.vue'

export default {
  name: 'app',
  components: {
    AppFooter,
    Splitpanes,
    GrcDB,
    GrcDialog,
    GrcButton,
    AppFrameTopMenu
  },
    data () {
      return {
        CurrentPath: "",
        LastWindowWidth:0,
        bgcolor:"transparent",
      }
  },
  methods: {

    SetAppHeaderVersion(pVersion)
    {
      this.$refs.AppFrameTopMenu.SetAppHeaderVersion(pVersion);
    },

    ChangePageBackground(pColor)
    {
      this.bgcolor = pColor;
      this.$refs.AppFooter.ChangeBackgroundColor(pColor);
    },

    MainResizeEvent()
    {
      var w = grccomp_getScreenSize().width;
      if (w != this.LastWindowWidth)
      {
        //this.CloseTopMenus();
      }

      this.LastWindowWidth = w;
      //console.log("resized: "+w);
    },


      async Init()
      {
        //console.log(GRCAPP_GetParameters.ALIAS);

        if (GRCAPP_PostParameters.XLMS == undefined)
        {
          //console.log("nincs param");
          gXLMS = "";
        }
        else
        {
          //console.log("XLMS: "+GRCAPP_PostParameters.XLMS);
          gXLMS = GRCAPP_PostParameters.XLMS;
        }

        //kiveve 2021.03.02
        this.$router.replace({ path: "blank" }).catch(err => {});

        
        this.$refs.GRCDB.ShowLoading(false);
       
        var QP = {
        };
        var Q;
        await this.$refs.GRCDB.GetData("App_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            alert(Q.APPERR[0].ERR);
            return;
        }

        if (Q.KARBANTARTAS[0].Karbantartas == 1)
        {
          document.location = Q.KARBANTARTAS[0].Karbantartas_Url;
          return;
        }


        gTextBook = Q.TEXTBOOK;

       
        this.$refs.GRCDB.HideLoading();
        
        gAppInitDone = true;

        //console.log(GRCAPP_GetParameters.ALIAS);
        this.NavigateToRoute(GRCAPP_GetParameters.ALIAS, true);
      },

      ChildForm_Navigate(pPath)
      {
        this.NavigateToRoute(pPath, true);
      },

      async NavigateToRoute(pPath, pFirstAttempt)
      {
        if (this.$router.currentRoute.path.toLowerCase() == "/blank") { gRouteMode = "replace"; }
        
        /*
        console.log(this.$router.currentRoute.path);
        console.log("ntr: "+pPath);
        console.log(gRouteMode);
        */
        
        if (pPath == "default")
        {
          var AT = grcmain_GetAppTypeID();

          pPath = "home";
        }

        var routeindex = -1;
        for(var i=0; i<this.$router.options.routes.length; i++)
        {
          if (this.$router.options.routes[i].path == "/"+pPath) { routeindex = i; }
        }

        if (routeindex < 0) { pPath = "nopage"; }

        var RightCheckResult = 1;

        if (RightCheckResult == 1)
        {
          this.CurrentPath = pPath;

          if (gRouteMode == "replace")
          {
            gRouteMode = "";
            this.$router.replace({ path: pPath }).catch(err => {});
          }
          else
          {
            this.$router.push({ path: pPath }).catch(err => {});
          }

        }
        else
        {
          if (pFirstAttempt) { this.NavigateToRoute("default", false); }
          else { this.NavigateToRoute("noright", false); }
        }

      },



    async HandleCommError(pErrorText)
    {

      pErrorText = ""+pErrorText;

      var RightCheckResult = -1000;
      var ErrorText = "";

      if (pErrorText.startsWith("UNKNOWN_ERR"))
      {
        RightCheckResult = -999;
        ErrorText = pErrorText.replace("UNKNOWN_ERR:","");
      }

      
      if (pErrorText.startsWith("COMM_ERROR"))
      {
        RightCheckResult = -998;
        ErrorText = pErrorText.replace("COMM_ERROR:","");
      }

      if (pErrorText.startsWith("RIGHT_ERROR"))
      {
        RightCheckResult = 0;
        ErrorText = pErrorText.replace("RIGHT_ERROR:","");
        this.NavigateToRoute("noright", true);
        return;
      }

      if (pErrorText.startsWith("FNC_ERROR"))
      {
        RightCheckResult = -1;
        ErrorText = pErrorText.replace("FNC_ERROR:","");

        this.NavigateToRoute("noright", true);
        return;
      }

      if (pErrorText.startsWith("SESSION_ERROR"))
      {
        RightCheckResult = -2;
        ErrorText = pErrorText.replace("SESSION_ERROR:","");

        this.LogoutOK();

        this.NavigateToRoute("bejelentkezes", true);
        return;
      }

      if (pErrorText.startsWith("APPVER_ERROR"))
      {
        RightCheckResult = -3;
        ErrorText = pErrorText.replace("APPVER_ERROR:","");
      }

      if (ErrorText == "") { ErrorText = pErrorText; }

      var arr = [-1000,-999,-998,0,-1];
      if (arr.includes(RightCheckResult))
      {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", ErrorText).then(res => { DialogResult = res; });
        return;
      }

      if (RightCheckResult == -2)
      {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Hiba", "A bejelentkezés elévült!").then(res => { DialogResult = res; });
        
        this.$refs.RELOGIN.ShowRelogin();

        return;
      }

      if (RightCheckResult == -3)
      {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", "Az alkalmazás verzió elévült, az új verzió letöltése automatikusan megtörténik!").then(res => { DialogResult = res; });

        location.reload(true);
        return;
      }

    },

  },

  created()
  {

  },


  mounted()
  {
    this.Init();
    gApp = this;

    this.LastWindowWidth = grccomp_getScreenSize().width;
  },

  updated()
  {

  },

  computed: {

  }  

}


</script>

<style>


</style>
